<div class="container">
  <div class="row">
    <div class="col-md-10">

      <!-- <div class="simple-title text-bold">
      Fuel quote for {{data.ICAO}} / {{data.IATA}}
    </div> -->
      <div class="content">
        <p>
          You can order fuel at these prices at <a href="https://www.evo-jet.com/user" target="_blank">EVO FuelWeb</a>
        </p>
      </div>

      <div class="list-quotes">
        @for (key of listKeys; track key) {
        <div class="item">
          <div class="title">
            {{data()[key]?.PriceResult?.name}}
          </div>
          <div class="params">
            <div class="params-item">
              <div class="content">
                <div class="name">
                  Effective
                </div>
                <div class="value">
                  {{data()[key]?.PriceResult?.summary?.Date_From}} - {{data()[key]?.PriceResult?.summary?.Date_To}}
                </div>
              </div>
            </div>
            <div class="params-item">
              @for (item of data()[key]?.PriceResult?.rows; track item) {
              <div class="price-item">
                <div class="name">
                  {{item.USG_From}} - {{item.USG_To}} USG
                </div>
                <div class="value">
                  {{item.Price}} USD/USG
                </div>
              </div>
              }
            </div>
          </div>
          <div class="notes">
            {{data()[key]?.PriceResult?.summary?.Notes}}
          </div>
        </div>
        }
      </div>

      <div class="content">
        <div class="title">
          Price Disclaimer
        </div>
        <p>
          While EVO Fuels endeavors to provide the most accurate jet fuel price estimates possible, occasionally our
          actual billing may not match our estimates due to unexpected changes in our suppliers’ market price, exchange
          rates, local fees, density and taxes, type of flight and destination. In such cases, EVO Fuels will pass any
          savings, or additional costs, onto the operator.
          For international uplifts, it is the responsibility of the aircraft operator to provide the required
          documentation to the relevant authorities and to ensure their flight crews accurately complete all necessary
          paperwork at the time of fueling, taking special care to REVIEW THE FUEL SLIP FOR ACCURACY BEFORE SIGNING.
        </p>
        <p>
          Please note that all non-fuel-related 3rd party charges are subject to a 2.4% administration fee.
        </p>
      </div>
    </div>
  </div>
</div>
